import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TermsConditionsRepository } from '@/core/domain/terms-conditions/repositories/terms-conditions.repository';
import { GetTermsConditionsUseCase } from '@/core/domain/terms-conditions/usecases/getTermsConditions.usecase';
import { TermsConditionsImplRepository } from './terms-conditions-impl.repository';

const getTermsConditionsUseCaseFactory = (
    repository: TermsConditionsRepository,
) => new GetTermsConditionsUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetTermsConditionsUseCase,
            useFactory: getTermsConditionsUseCaseFactory,
            deps: [TermsConditionsRepository],
        },
        {
            provide: TermsConditionsRepository,
            useClass: TermsConditionsImplRepository,
        },
    ],
})
export class TermsConditionsDataModule {}
